// extracted by mini-css-extract-plugin
export default {"cls1":"VeloLabelledItem-Value_cls1__gARxL","cls2":"VeloLabelledItem-Value_cls2__75OBv VeloLabelledItem-Value_cls1__gARxL","splitWords":"VeloLabelledItem-Value_splitWords__rb--d"};